import React, { Component } from "react";

import "../CSS/style_general.css";


import IconDone         from "material-ui/svg-icons/action/done"
import IconDoneAll      from "material-ui/svg-icons/action/done-all"
import IconClear        from "material-ui/svg-icons/content/clear"


export default class TabellaSpecifiche extends Component {
  constructor(props) {
    super(props);
    
    this.state = {

    }
  }

  icon = val => {
      var iconList = this.props.Icons || [];
      return iconList[val]
  }

  render() {

    var USERLANGUAGE = this.props.Language;

    const styles = {
        ul : {
            padding: "10px"
        },
        li : {
            color         : "black",
            listStyleType : "none",
            padding       : "0",
            marginBottom  : "10px",
            fontSize      : "20px"
        },
        left : {
            width: "70%"
        },
        right : {
            width: "29%"
        },
        leftPrezzo : {
            width: "40%",
            fontSize : "25px",
            fontWeight: "bold",
        },
        rightPrezzo : {
            width: "60%",
            fontSize : "25px",
            fontWeight: "bold",
        },
        title : {
            fontSize : "35px",
            textAlign : "center",
            color     : "#6b9add",
            fontWeight: "bold",
            textTransform : "uppercase"
        }
    }

    return(
        <div>
            <div style={styles.title}>
                {this.props.List[0]}
            </div>

            <ul style={styles.ul}>
                <li style={styles.li} >
                    <div className="clearfix">
                        <div className="left" style={styles.left}>Bilance</div>
                        <div className="right" style={styles.right}>{this.icon(this.props.List[1])}</div>
                    </div>
                </li>
                <li style={styles.li} >
                    <div className="clearfix">
                        <div className="left" style={styles.left}>Bilance I/O</div>
                        <div className="right" style={styles.right}>{this.icon(this.props.List[2])}</div>
                    </div>
                </li>
                <li style={styles.li} >
                    <div className="clearfix">
                        <div className="left" style={styles.left}>Impianti</div>
                        <div className="right" style={styles.right}>{this.icon(this.props.List[3])}</div>
                    </div>
                </li>
                <li style={styles.li} >
                    <div className="clearfix">
                        <div className="left" style={styles.left}>Aziende</div>
                        <div className="right" style={styles.right}>{this.icon(this.props.List[4])}</div>
                    </div>
                </li>
                <li style={styles.li} >
                    <div className="clearfix">
                        <div className="left" style={styles.left}>Campi Personalizzati</div>
                        <div className="right" style={styles.right}>{this.icon(this.props.List[5])}</div>
                    </div>
                </li>
                <li style={styles.li} >
                    <div className="clearfix">
                        <div className="left" style={styles.left}>Tabelle Personalizzate</div>
                        <div className="right" style={styles.right}>{this.icon(this.props.List[6])}</div>
                    </div>
                </li>
                <li style={styles.li} >
                    <div className="clearfix">
                        <div className="left" style={styles.left}>Stampanti</div>
                        <div className="right" style={styles.right}>{this.icon(this.props.List[7])}</div>
                    </div>
                </li>
                <li style={styles.li} >
                    <div className="clearfix">
                        <div className="left" style={styles.left}>Stampe Personalizzate</div>
                        <div className="right" style={styles.right}>{this.icon(this.props.List[8])}</div>
                    </div>
                </li>
                <li style={styles.li} >
                    <div className="clearfix">
                        <div className="left" style={styles.left}>Condivisione Dati </div>
                        <div className="right" style={styles.right}>{this.icon(this.props.List[9])}</div>
                    </div>
                </li>

                <li style={styles.li} >
                    <div className="clearfix" style={{marginTop: "50px", marginBottom: "50px"}}>
                        <div className="left" style={styles.leftPrezzo}>Prezzo </div>
                        <div className="right" style={styles.rightPrezzo}>{this.props.List[10] }</div>
                    </div>
                </li>
            </ul>
        </div>
        
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/component_TabellaSpecifiche.js